/* Small React error boundary — prevents the entire page turning black
 * when a child component throws. Renders a friendly recovery card + a
 * "Reload" button, and logs the error to the browser console + toast.
 */
import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

export class SafeBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[SafeBoundary]", error, info?.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="rounded-lg border border-red-500/30 bg-red-500/5 p-6 space-y-3" data-testid="safe-boundary-fallback">
        <div className="flex items-center gap-2 text-red-300">
          <AlertTriangle size={16} />
          <div className="font-display text-base">Algo correu mal ao renderizar esta secção</div>
        </div>
        <div className="text-xs text-white/70 font-mono">
          {String(this.state.error?.message || this.state.error).slice(0, 300)}
        </div>
        <div className="flex gap-2 pt-2">
          <button
            onClick={this.reset}
            data-testid="safe-boundary-reset"
            className="text-xs font-mono uppercase tracking-wider bg-[color:var(--hq-cyan)] text-black px-3 py-1.5 rounded flex items-center gap-1.5"
          >
            <RefreshCw size={11} /> tentar de novo
          </button>
          <button
            onClick={() => window.location.reload()}
            className="text-xs font-mono uppercase tracking-wider border border-white/20 hover:border-white/40 text-white/80 px-3 py-1.5 rounded"
          >
            recarregar página
          </button>
        </div>
      </div>
    );
  }
}
